// ─── Quota d'ESPACES — combien de contenants je peux posséder ─────
// Un espace n'est pas un élément : il ne consomme pas de jeton, il se compte à
// part (cf. `useQuotaElements` pour les calendriers, inventaires, plans).
// Par défaut 1 pour tous les plans ; l'administration relève ce chiffre plan par
// plan, et un valideur peut se le régler pour tester (surcharge IVV).
//
// Seuls les espaces POSSÉDÉS comptent : être membre de l'espace d'un autre ne
// consomme rien — sinon accepter une invitation ferait sauter son propre quota.
import { useEffect, useMemo, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../auth/AuthContext';
import { useEspace } from '../espace/EspaceContext';
import { dotationEspaces } from './jetons';

const estProprio = (e, uid) => !!e && (e.creePar === uid || (e.membres && e.membres[uid] === 'proprietaire'));

export function useQuotaEspaces() {
  const { user } = useAuth();
  const { espaces = [], pret: espacesPrets = true } = useEspace();
  const [cfg, setCfg] = useState(null);   // null = pas encore lu

  useEffect(() => onSnapshot(doc(db, 'config', 'fonctionnalites'),
    (snap) => setCfg(snap.exists() ? { plans: snap.data().plans || {} } : { plans: {} }),
    () => setCfg({ plans: {} })), []);

  const possedes = useMemo(
    () => (espaces || []).filter(e => estProprio(e, user?.uid)).length,
    [espaces, user?.uid]);

  const max = dotationEspaces(cfg || {}, user);
  // Comme pour les éléments : tant qu'on n'a pas lu la config et la liste, on ne
  // conclut pas « il reste de la place ».
  const pret = cfg !== null && espacesPrets;
  return {
    possedes, max, pret,
    peutCreer: pret && possedes < max,
    atteint: pret && possedes >= max,
  };
}

export default useQuotaEspaces;
